
<template>
  <div>
    <div >
        <div v-if='video_url == ""'>
          <div :id='"upload" + type' class=" commonStyle w-100" v-bind:class="{'styleA':styleA, 'styleB':styleB,'isImage':isImage }" :style="{background: 'url(' + imaga_url + ')'}"   @dragover.prevent="changeStyle($event,'ok')" @dragleave.prevent="changeStyle($event,'no')" @drop.prevent="uploadResume($event, type) " >
            <label :for="'image' + type + index" class="button" :class='{"isImage":isImage}'>
              <b-icon v-if='!isImage' icon="image" style="width: 80px; height: 80px;"></b-icon>
              <input :id="'image' + type + index" type="file" @change="uploadResume($event, type)" style="display:none;" accept="image/*">
            </label>
          </div>
        </div>
        <div v-else>
          <label :for="'image' + type + index" class='video-form button'>
            ＋動画を変更する場合は、こちらからファイルを選択してください
            <input :id="'image' + type + index" type="file" @change="uploadResume($event, type)" style="display:none;" accept="video/mp4">
          </label>
          <video controls v-if="video_url" class="video" :key="video_url">
            <source :src="video_url" type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'>
          </video>
        </div>
      </div>
    </div>
</template>

<script>
export default {
   props:{
    video_url: {
      type: String,
      default: null
    },
    index: {
      type: Number,
      default: 1
    },
    type: {
      type: String,
      default: 'images'
    }
  },
  components: {
  },
  data () {
    return {
      styleA: true,
      styleB: false,
      isImage: false,
      image: '',
      image_pdf: null,
      image_name: "",
      options: {
        autoplay: false,
        volume: 0.6,
      },
      sources: [],
    }
  },
  mounted() {
  },
  watch: {
    video_url() {
      console.log(this.video_url)
      this.sources = [{
          src: this.video_url,
          type: 'video/mp4'
        }]
      console.log("--------")
      console.log(this.sources)
    }
  },
  methods:{
    changeStyle: function(event,flag){
        if(flag=='ok'){
            this.styleA = false;
            this.styleB = true;
        }else{
            this.styleA = true;
            this.styleB = false;
        }
    },
    uploadResume: function(event){
      this.styleA = true;
      const files = event.target.files ? event.currentTarget.files : event.dataTransfer.files;
      const file = files[0];
      const reader = new FileReader();
      reader.onload = event => {
        this.isImage = true
        this.video_url = event.target.result
        this.image = event.target.result;
        this.$emit('addImage', {'image': event.target.result, 'type': this.type, 'index': this.index});
      };
      this.image_name = file.name;
      reader.readAsDataURL(file);
      document.getElementById('image' + this.type + this.index).files = files;
    },
  },
}
</script>
<style scoped lang="scss">
.button{
  border:0px solid black;
  padding:3px;
  border-radius:5px;
  background-color: none;
}
.button p {
  color:black;
  font-size: 20px;
  margin-top:10px;
  margin-left:10px;
  margin-right: 10px;
}
.commonStyle{
  padding: 1rem;
  text-align:center;
}
.styleA{
  border:3px dotted gray;
  background-color: #F5F5F8 !important;
  background-size: contain !important;
  background-repeat : no-repeat !important;
}

.isImage{
  min-height: 85px;
  background-position : center !important;
}
.styleB{
  border:3px dotted rgba(0,200,0,0.7);
}
.video {
  width:50%;
}
.video-form {
  background-color: #f4f4f4;
  width: 100%;
  padding: 15px 10px;
  text-align: center;
}
</style>
